import * as React from 'react';
import { Button, FlexRow, Grid, Icon, IconSize, IconType } from 'ui-toolkit';

interface IPolicyHeaderButtons {
  showSaveSuccess: boolean;
  disableFinalize: boolean;
  onNext: () => void;
}

export default class PolicyHeaderButtons extends React.Component<IPolicyHeaderButtons, {}> {
  public static defaultProps: Partial<IPolicyHeaderButtons> = {
    disableFinalize: false,
  };

  public render() {
    return (
      <FlexRow justifyContent={'flex-end'}>
        {this.props.showSaveSuccess ? (
          <Grid columnCount={2} columnWidth={'min-content'}>
            <Icon type={IconType.Check} size={IconSize.Small} />
            Updated!
          </Grid>
        ) : null}
        <Button intent="primary" onClick={this.props.onNext}>
          Next
        </Button>
      </FlexRow>
    );
  }
}
